var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.for-each.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import 'intersection-observer';
import { helper } from "../../common/helper";
var RTLImg = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLImg, _LitElement);
  function RTLImg() {
    var _this;
    _classCallCheck(this, RTLImg);
    _this = _callSuper(this, RTLImg);
    _this.isOnScreen = false;
    _this.placeholder = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
    if (_this.lazyload !== undefined) _this.lazyload = true;
    var ua = window.navigator.userAgent;
    var isIE = /MSIE|Trident/.test(ua);
    if (!isIE) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            io.unobserve(entry.target);
            _this.isOnScreen = true;
          }
        });
      }, {
        rootMargin: '500px'
      });
      io.observe(_assertThisInitialized(_this));
    } else {
      _this.isOnScreen = true;
    }
    return _this;
  }
  _createClass(RTLImg, [{
    key: "createRenderRoot",
    value: function createRenderRoot() {
      return this;
    }
  }, {
    key: "render",
    value: function render() {
      var width = this.width;
      if (width == undefined) width = 800;
      var width1 = width;
      var width2 = Math.ceil(width * 0.7333);
      var width3 = Math.ceil(width * 0.5333);
      var height = this.height;
      //if (height == undefined || height == 0) height = Math.ceil(width * 9 / 16);

      return html(_t || (_t = _`
            <div style="min-height: 1px; display: inline-block;">
                ${0}
            </div>
        `), this.isOnScreen ? html(_t2 || (_t2 = _`
                    ${0}
                `), height ? html(_t3 || (_t3 = _`<img class="media-image__image" src="${0}" width="${0}" height="${0}" />`), helper.stockify(this.src, width1), width1, height) : html(_t4 || (_t4 = _`<img class="media-image__image" src="${0}" width="${0}" />`), helper.stockify(this.src, width1), width1)) : '');
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        src: {
          type: String
        },
        width: {
          type: Number
        },
        height: {
          type: Number
        },
        isOnScreen: {
          type: Boolean
        }
      };
    }
  }]);
  return RTLImg;
}(LitElement);
export { RTLImg as default };
window.customElements.define('rtl-img', RTLImg);